function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3216",
    transform: "translate(-1864 -16)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 725",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1864 16)",
    style: {
      fill: "#d2d3d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-person",
    d: "M14 14a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
    transform: "translate(1870 22)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user_profile.3776de3dfd0771ca4521d3cc843b6472.svg";
export { ForwardRef as ReactComponent };